import React, { useEffect, useState } from "react";
import { Server2 } from "../../redux/actions/auth/auth.actions";
import axios from "axios";
import StarRating from "./StarRating";
import { MdOutlineReviews } from "react-icons/md";

const ProductReviews = ({ productId }) => {

  const [reviews, setReviews] = useState([]);

  const getReviews = () => {

		let data = JSON.stringify({
			id: productId,
		});

		var config = {
			method: "post",
			url: Server2 + "/products/get-reviews",
			headers: { "Content-Type": "application/json" },
			data: data,
		};
		axios(config)
			.then((response) => {
        console.log(response)
				setReviews(response.data);
			})
			.catch((err) => {
				console.log(err, "error");
			});
	}

	useEffect(() => {
		getReviews();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [productId]);

  return (
    <div className="bg-white">

      {/* Reviews List */}
      <div className="">

        {reviews.length === 0 ? (
          <div className="text-gray-500 mt-4 text-center py-10">
            No reviews yet
          </div>
        )
        :

        <div className="mt-4">

          <h6 className="ps-2 mb-2">Product Reviews</h6>

          <div className="d-flex flex-column rounded mx-1 shadow px-4 pb-4 pt-3 gap-3">
            {reviews.map((r) => (
              <div key={r._id}>
    
                <div className="">
    
                  {/* Meta */}
                  <div className="mt-2 d-flex align-items-center pb-0 gap-2">
    
                    {r.buyer && (
                      <>
                      <div className="d-flex justify-content-start gap-2">
												<img
													src={r?.buyer?.profile_pic}
													alt={'name'}
													className="rounded-circle border border-white"
													style={{
														width: 30,
														height: 30,
														objectFit: "cover",
													}}
												/>
											</div>
                      </>
                    )}

                    <p className="pb-0">{r?.buyer?.fname}</p>
    
                    <span className="text-secondary">
                      {new Date(r.createdAt).toLocaleDateString()}
                    </span>
    
                  </div>
    
                  {/* Stars */}
                  <div className="mt-1">
                    <StarRating value={r.rating} size={18} disabled/>
                  </div>
    
                  {/* Review text */}
                  {r.review !== "" ? (
                    <p className="text-dark text-sm">
                     <MdOutlineReviews className=""/> {r.review}
                    </p>
                  ) : (
                    <p className="text-secondary mt-1 text-xs">
                      No written review
                    </p>
                  )}
    
    
                </div>
    
              </div>
            ))}
          </div>
        </div>
        }

      </div>

    </div>
  );
};

export default ProductReviews;